import { Component } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  username: string;
  password: string;
  loading = false;
  showError = false;

  constructor(private authService: AuthService, private router: Router) {}

  login() {
    this.loading = true;
    this.showError = false;
    this.authService.login(this.username, this.password).subscribe({
      next: (response) => {
        console.log('success');
        this.loading = false;
        this.router.navigate(['/mai-nap'])
      },
      error: (error) => {
        console.log(error)
        this.loading = false;
        this.showError = true;
      }
    })
  }



}
